export const SHOW_SNACKBAR = 'MAIN/SHOW_SNACKBAR'
export const CLOSE_SNACKBAR = 'MAIN/CLOSE_SNACKBAR'
export const RELOAD_HEADER = 'HEADER/RELOAD_HEADER'
export const LOGIN_MOBILE = 'LOGIN/LOGIN_MOBILE'
export const PROFILE_TAB = 'PROFILE/PROFILE_TAB'
